/**
 * B.H.
 */
import { Navigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import { isFeatureOn } from "../../portalSettings";

/**
 * מסך שנפתח רק לריסיילר שההגדרה פתוחה בו - הרשמה, שחזור סיסמה, שחזור שם משתמש.
 *
 * **זה אינו השער.** השערים הם בשרת, ולכל אחת מהשלוש יש שניים: ה-Host שממנו נכנסו,
 * ואחריו הריסיילר של הלקוח עצמו (בהרשמה - שורת הריסיילר שהלקוח ייווצר תחתיה,
 * בשחזור - זה שהמייל יוצא ממותג בשמו). מה שכאן מונע הוא זרימה שנפתחת ונחסמת
 * בסופה: מסך שממלאים בו טופס, לוחצים, ורק אז שומעים שהפעולה אינה מוצעת.
 *
 * שלושת המסלולים באמת צריכים את זה, ולא רק ההרשמה: קישור שמור במועדפים, קישור
 * מהיסטוריית הדפדפן, ומייל ישן - כולם נוחתים ישירות על המסך בלי לעבור במסך
 * ההתחברות שמסתיר את הקישור.
 *
 * ההפניה היא ל-`/login` ולא למסך שגיאה: מי שהגיע לכאן רצה להיכנס, ובריסיילר כזה
 * הדרך היא דרך הריסיילר. מסך שגיאה היה מסלול מבוי סתום.
 *
 * `children` ולא `Outlet`, ובכוונה: זה שער על מסלול אחד, ולא שכבת ניתוב שמסלולים
 * מצטרפים אליה. שכבה כזו הייתה מזמינה מסלול שנכנס תחתיה בלי שמישהו התכוון לגדר
 * אותו - ובמסלולים האלה, שער שנוסף בשוגג הוא מסך שנעלם ללקוח.
 *
 * **`/create-password` אינו מגודר**, ובמכוון: הוא הפדיון של קישור שכבר נשלח, ולא
 * הצעה של פעולה. ריסיילר שכיבה את השחזור חצי שעה אחרי שהמייל יצא היה משאיר לקוח
 * עם קישור תקין שאינו נפתח. כך גם השרת - `resetPassword` אינו בודק את ההגדרה.
 */
const AllowFeatureByReseller = ({ feature, children }) => {
    const reseller = useSelector((state) => state.reseller.value);
    const status = useSelector((state) => state.reseller.status);

    /**
     * בקשה שנכשלה **פותחת** את המסך, ואינה משאירה אותו בטעינה.
     *
     * זו אותה נפילה לאחור של השרת בדיוק (`isFeatureEnabled(..., fallback = true)`
     * ו-`isFeatureOn` כאן): "אין מידע" אינו "אסור". קודם כל מצב שאינו `succeeded`
     * הראה ספינר, כלומר בליפ אחד ב-`getResellerData` היה משאיר מי שמנסה לשחזר
     * סיסמה מול גלגל מסתובב בלי הסבר ובלי דרך הלאה - וזה מסך שהשרת ממילא היה
     * מקבל את הפנייה ממנו. ריסיילר שכיבה את הפעולה עדיין נדחה בשרת, בהודעה
     * מתורגמת שהמסך יודע להציג.
     */
    if (status === "failed") {
        return children;
    }

    // עד שיש תשובה - טעינה. מסך שמניח "פתוח" ואז מנווט משאיר את המשתמש בטופס שנעלם
    // מתחתיו, ומסך שמניח "סגור" מפנה למי שכן רשאי.
    if (status !== "succeeded") {
        return <div className="loader-container"><div className="loader"></div></div>;
    }
    if (!isFeatureOn(reseller, feature)) {
        return <Navigate to="/login" replace />;
    }
    return children;
};

export default AllowFeatureByReseller;
